import http from "@/lib/http/client"
import { BillingPlans, PaginatedCreditHistory, PaymentUrlResponse, SubscriptionUrlResponse } from "@/types/api"

export const getBillingPlans = async (): Promise<BillingPlans> => {
  const res = await http.get(`/billing/plans`)
  return res.data
}

export const createPaymentUrl = async (planId: string): Promise<PaymentUrlResponse> => {
  const res = await http.post(`/billing/payment-url`, { plan_id: planId })
  return res.data
}

export const createSubscriptionUrl = async (): Promise<SubscriptionUrlResponse> => {
  const res = await http.post(`/billing/subscription-url`, {})
  return res.data
}

export const listCreditHistory = async (limit: number = 10, offset: number = 0): Promise<PaginatedCreditHistory> => {
  const res = await http.get(`/billing/credit-history`, { params: { limit, offset } })
  return res.data
}
